//src/components/Other-Pages/TermsOfService.js

import React from "react";

export default function TermsOfService() {
  const containerStyle = {
    maxWidth: "850px",
    margin: "0 auto",
    padding: "40px 20px",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    lineHeight: 1.6,
    color: "#222",
  };

  const homeLinkStyle = {
  display: "inline-block",
  marginBottom: "20px",
  color: "#2b6cb0",
  textDecoration: "none",
  fontSize: "14px",
};

  const headingStyle = {
    marginTop: "32px",
  };

  const handleMouseOver = (e) => {
    e.currentTarget.style.textDecoration = "underline";
    };

    const handleMouseOut = (e) => {
    e.currentTarget.style.textDecoration = "none";
    };

  return (
    <div style={containerStyle}>
        <a
        href="/"
        style={homeLinkStyle}
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
        >
        ← Return to Home
        </a>
      <h1>Terms of Service</h1>
      <p><strong>Last Updated:</strong> February 13, 2026</p>

      <p>
        Welcome to Sparks Psychological Services, LLC & Associates (“Company,” “we,” “our,” or “us”).
        By accessing or using our website, you agree to be bound by these Terms of Service (“Terms”).
        If you do not agree, please do not use this website.
      </p>

      <h2 style={headingStyle}>Use of Website</h2>
      <p>
        This website is provided for informational purposes only. You agree to use this website only
        for lawful purposes and in a manner that does not infringe upon the rights of others or
        restrict their use of the website.
      </p>

      <h2 style={headingStyle}>No Medical or Mental Health Advice</h2>
      <p>
        The content on this website is intended for general informational purposes only and is not a
        substitute for professional medical or mental health advice, diagnosis, or treatment.
      </p>

      <p>
        Always seek the advice of a qualified healthcare provider regarding any questions you may
        have about a medical or mental health condition. Never disregard professional advice or
        delay seeking it because of something you have read on this website.
      </p>

      <h2 style={headingStyle}>No Therapist-Client Relationship</h2>
      <p>
        Use of this website, including contacting us through the website, does not establish a
        therapist-client relationship. A professional relationship is formed only after appropriate
        intake procedures have been completed and both parties have agreed to engage in services.
      </p>

      <p>
        Electronic communication through this website may not be secure and should not be used to
        transmit sensitive or confidential information.
      </p>

      <h2 style={headingStyle}>Emergency Situations</h2>
      <p>
        This website is not intended for emergency communications. If you are experiencing a mental
        health emergency, call 911, contact your local emergency services, or go to the nearest
        emergency room immediately.
      </p>

      <h2 style={headingStyle}>Privacy</h2>
      <p>
        Your use of this website is also governed by our Privacy Policy. Please review it to
        understand how we collect, use, and safeguard your information.
      </p>

      <h2 style={headingStyle}>Intellectual Property</h2>
      <p>
        All content on this website, including text, graphics, logos, and other materials, is the
        property of Sparks Psychological Services, LLC & Associates unless otherwise stated and is
        protected by applicable intellectual property laws.
      </p>

      <p>
        You may not reproduce, distribute, modify, or republish any content from this website
        without prior written permission.
      </p>

      <h2 style={headingStyle}>Third-Party Links</h2>
      <p>
        This website may contain links to third-party websites for your convenience. We do not
        control and are not responsible for the content, privacy practices, or accuracy of
        third-party websites.
      </p>

      <h2 style={headingStyle}>Disclaimer of Warranties</h2>
      <p>
        This website is provided on an “as is” and “as available” basis. We make no warranties,
        expressed or implied, regarding the operation or availability of the website or the
        accuracy of the information provided.
      </p>

      <h2 style={headingStyle}>Limitation of Liability</h2>
      <p>
        To the fullest extent permitted by law, Sparks Psychological Services, LLC & Associates
        shall not be liable for any indirect, incidental, consequential, or punitive damages
        arising out of your access to or use of this website.
      </p>

      <h2 style={headingStyle}>Indemnification</h2>
      <p>
        You agree to indemnify and hold harmless Sparks Psychological Services, LLC & Associates
        from any claims, damages, liabilities, costs, or expenses arising from your misuse of the
        website or violation of these Terms.
      </p>

      <h2 style={headingStyle}>Modifications</h2>
      <p>
        We reserve the right to modify these Terms at any time. Updated Terms will be posted on this
        page with a revised effective date.
      </p>

      <h2 style={headingStyle}>Governing Law</h2>
      <p>
        These Terms are governed by the laws of the State of Ohio, without regard to conflict-of-law
        principles.
      </p>

      <h2 style={headingStyle}>Contact Information</h2>
      <p>
        Sparks Psychological Services, LLC & Associates<br />
        8118 Corporate Way, Suite 121<br />
        Ohio 45040<br />
        Email: officemanager@sparkspsychservices.com<br />
        Phone: 513-297-3455
      </p>
    </div>
  );
}

